import React, { PropTypes } from 'react'

import SectionText from '../presentational/SectionText';
import DotPoints from '../presentational/DotPoints';
import data from '../../core/data';

import superLotion from '../../images/phyto/superLotion.jpg';
import vitaminCream from '../../images/phyto/vitamin-cream.jpg';
import clearCream from '../../images/phyto/clear-cream.jpg';
import bbCream from '../../images/bb-cream/bb-cream-nude.jpg';

import cx from 'classnames';
import { Track, TrackedDiv, TrackDocument } from 'react-track';
import { topTop,
        topBottom,
        centerCenter,
        topCenter,
        bottomBottom,
        bottomTop,
        getDocumentRect,
        getDocumentElement,
        calculateScrollY } from 'react-track/tracking-formulas';
import {tween, combine} from 'react-imation';
import {rgb, rgba, scale, rotate,
        px, percent, translate3d} from 'react-imation/tween-value-factories';

const homecare = data.index.homecare;

const superLotionArray = homecare.superLotion.array;
const superLotionBody = homecare.superLotion.body;

const vitaminArray = homecare.vitaminCream.array;
const vitaminBody = homecare.vitaminCream.body;

const clearArray = homecare.clearCream.array;
const clearBody = homecare.clearCream.body;

const bbArray = homecare.bbCream.array;
const bbBody = homecare.bbCream.body;

const Product = (props) => {
  return (
    <div className="container product">
      <TrackDocument formulas={[getDocumentElement, getDocumentRect, calculateScrollY,
                               topTop, topBottom, topCenter, centerCenter]}>
      {(documentElement, documentRect, scrollY, topTop,
        topBottom, topCenter, centerCenter, bottomBottom, bottomTop) =>
        <div className="row">
          <div className="col-md-6">
            <Track component="div" formulas={[topBottom, topCenter]}>
              {(DIV, posTopBottom, posTopCenter) =>
                <DIV
                  style={tween(scrollY, {
                    [posTopBottom]: { transform: translate3d(-100,0,0), opacity: 0 },
                    [posTopCenter]: { transform: translate3d(0,0,0), opacity: 1 }
                  })}>
                  <h3 className="heading">{ props.heading }</h3>
                  <p>{ props.body }</p>
                </DIV>
            }</Track>
            <h3>Benefits:</h3>
            <Track component="div" formulas={[topBottom, topCenter]}>
              {(DIV, posTopBottom, posTopCenter) =>
                <DIV>
                  <DotPoints className={cx('herbs',{'animated': scrollY > (posTopCenter-150)})} array={ props.array } />
                </DIV>
            }</Track>
          </div>
          <div className="col-md-offset-1 col-md-5">
            <div className="right">
              <img className={ props.imageClass } src={ props.image } />
            </div>
          </div>
        </div>
      }</TrackDocument>
    </div>
  )
}

const Homecare = (props) => {
  return (
    <section id="homecare">
      <header>
        <h1>Your Homecare</h1>
        <h2>Cleanse</h2>
      </header>
      <Product
        heading="Herbal Super Lotion"
        body={ superLotionBody }
        array={ superLotionArray }
        image={ superLotion }
        imageClass="superlotion"
      />
      <h2>Moisturise</h2>
        <Product
          heading="Vitamin Cream"
          body={ vitaminBody }
          array={ vitaminArray }
          image={ vitaminCream }
        />
        <Product
          heading="Clear Cream"
          body={ clearBody }
          array={ clearArray }
          image={ clearCream }
        />
      <h2>Protect</h2>
        <Product
          heading="Blemish Balm"
          body={ bbBody }
          array={ bbArray }
          image={ bbCream }
        />
    </section>
  )
}

export default Homecare;



/** WEBPACK FOOTER **
 ** ./src/components/containers/Homecare.jsx
 **/